import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { DOCTOR } from "@/data/static";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/treatments", label: "Treatments" },
  { to: "/gallery", label: "Gallery" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-3 bg-white/85 backdrop-blur-xl backdrop-saturate-150 border-b border-white/30 shadow-sm" : "py-5 bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="container-x flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="logo">
          <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-primary to-primary-light flex items-center justify-center text-white font-bold font-heading">
            A
          </div>
          <div className="leading-tight">
            <div className="font-heading font-semibold text-primary text-base">Aastha Maternity and Ortho Care Centre</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Maternity & Ortho · Sasaram</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  isActive ? "bg-primary/10 text-primary" : "text-slate-700 hover:text-primary hover:bg-slate-100"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${DOCTOR.phoneRaw}`} className="flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-primary" data-testid="navbar-phone">
            <Phone className="w-4 h-4" /> {DOCTOR.phone}
          </a>
          <Link to="/appointment" className="btn-primary text-sm !py-3 !px-5" data-testid="navbar-book-btn">
            Book Appointment
          </Link>
        </div>

        <button
          className="lg:hidden p-2 rounded-lg bg-white/60 backdrop-blur"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden mt-3 container-x" data-testid="navbar-mobile-menu">
          <div className="glass rounded-2xl p-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-sm font-medium ${isActive ? "bg-primary text-white" : "text-slate-700 hover:bg-slate-100"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/appointment" className="btn-primary text-sm mt-2 justify-center">Book Appointment</Link>
          </div>
        </div>
      )}
    </header>
  );
}
